import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { debounce } from 'lodash';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { calculatePeriodValueBaseOnPreviousPeriod, convertToOpposite } from 'components/BusinessToolForm/utils/helpers';

import { observedFields } from '../../utils/form';

export const useGetOtherNonCurrentAssetsCalculation = () => {
  const { setValue } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  const [otherNonCurrentAssetsFiled] = observedFields.otherNonCurrentAssets.setCalculatedValueFieldNames;

  const getOtherNonCurrentAssetsCalculationHandler = useMemo(
    () =>
      debounce((content) => {
        if (!canAccess) return;

        const [initialOtherNonCurrentAssets, investingActivitiesTable] = content;
        const purchaseOtherNonCurrentAssetsPeriodValues = convertToOpposite(investingActivitiesTable[0]);
        const longTermInvestments = calculatePeriodValueBaseOnPreviousPeriod(
          purchaseOtherNonCurrentAssetsPeriodValues,
          initialOtherNonCurrentAssets,
        );

        setValue(otherNonCurrentAssetsFiled, longTermInvestments);
      }, 500),

    [],
  );

  return getOtherNonCurrentAssetsCalculationHandler;
};
